import { useAllUsers, UserDataType } from 'api/user/useAllUser'
import { UpdateUserModal } from 'components/modals/UpdateUserModal'
import { startTransition, useState } from 'react'

export const UserList = () => {
  const { users, mutate } = useAllUsers()
  const [selectUser, setSelectUser] = useState<UserDataType>()

  return (
    <>
      <div className="max-h-[600px] overflow-auto">
        <table className="w-full border-collapse whitespace-nowrap text-sm">
          <thead className="sticky top-0 z-10">
            <tr className="border-b-2 border-[#ddd] bg-[#f8f9fa]">
              <th className="px-4 py-3 text-left text-sm font-semibold text-[#555]">
                ユーザーID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-[#555]">
                ユーザー名
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-[#555]">
                メールアドレス
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-[#555]">
                権限
              </th>
            </tr>
          </thead>
          <tbody>
            {(users ?? []).map((user) => (
              <tr
                key={user.code}
                className="cursor-pointer border-b border-[#eee] hover:bg-[#f8f9fa]"
                onClick={() => startTransition(() => setSelectUser(user))}
              >
                <td className="px-4 py-3">{user.code}</td>
                <td className="px-4 py-3 text-[#01695C] underline">
                  {user.lastName} {user.firstName}
                </td>
                <td className="px-4 py-3">{user.email}</td>
                <td className="px-4 py-3">
                  {user.authorityCode === 'ADMIN' ? '管理者' : '一般'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {selectUser && (
        <UpdateUserModal
          userData={selectUser}
          onClose={() => setSelectUser(undefined)}
          updateUserList={() => mutate()}
        />
      )}
    </>
  )
}
